import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_lef_v2",
  "use": "icon-icon_arrow_lef_v2-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-icon_arrow_lef_v2\"><path d=\"M13.926 2.336a.833.833 0 0 0-1.179 0l-7.071 7.07a.83.83 0 0 0-.237.484l-.007.106a.83.83 0 0 0 .244.59l7.071 7.07a.833.833 0 0 0 1.179-1.178L7.444 9.996l6.482-6.482a.833.833 0 0 0 0-1.178Z\" fill=\"#EBD0A9\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol